import { Routes } from '@angular/router';
import { ErrorComponent } from './components/common/error/error.component';
import { AnnulationGuard } from './guards/annulation.guard';
import { authGuard } from './guards/auth-guard';
import { TechnicalErrorComponent } from './components/common/technical-error/technical-error.component';
import { SuiviGuard } from './guards/suivi-guard';
import { GenericMessageComponent } from './components/common/generic-message/generic-message.component';

export const routes: Routes = [
    { path: '', pathMatch: 'full', redirectTo: '/accueil' },
    {
        path: 'accueil',
        data: {breadcrumbLabel: 'Résiliation', isBase: true},
        loadComponent: () =>
            import('./components/demande-resiliation/demande-resiliation.component')
                .then(module => module.DemandeResiliationComponent),
        canActivate: [authGuard, SuiviGuard],
    },
    {
        path: 'suivi',
        data: {breadcrumbLabel: 'Suivi', isBase: true},
        loadComponent: () =>
            import('./components/suivi-resiliation/suivi-resiliation.component')
                .then(module => module.SuiviResiliationComponent),
        canActivate: [authGuard, SuiviGuard],
    },
    {
        path: 'annuler',
        data: {breadcrumbLabel: 'Annuler', showBase: true},
        loadComponent: () =>
            import('./components/annuler-resiliation/annuler-resiliation.component')
                .then(module => module.AnnulerResiliationComponent),
        canActivate: [
            authGuard,
            AnnulationGuard
        ]
    },
    {
        path: 'retractation/accueil',
        data: {breadcrumbLabel: 'Rétractation', isBase: true},
        loadComponent: () =>
            import('./components/demande-retractation/demande-retractation.component')
                .then(module => module.DemandeRetractationComponent),
        canActivate: [authGuard],
    },
    {
        // Nouveau parcours autonome pour le recueil de motifs (Portabilité)
        path: 'recueillMotifsPorta',
        data: {
            breadcrumbLabel: {
                sfr: 'Motif de résiliation de votre offre',
                red: 'Motif de résiliation de mon offre'
            },
            isBase: true
        },
        loadComponent: () =>
            import('./components/RecueilMotifsPorta/recueil-motifs-porta.component')
                .then(module => module.RecueilMotifsPortaComponent),
        canActivate: [authGuard], // Uniquement authGuard car le suivi de résiliation classique ne s'applique pas ici
    },
    {
        data: {breadcrumbLabel: 'Erreur', showBase: true},
        path: 'error', component: ErrorComponent
    },
    {
        path: 'recueillMotifsPorta/generic-message',
        component: GenericMessageComponent
    },
    {
        data: {breadcrumbLabel: 'Erreur', showBase: true},
        path: 'erreur-technique', component: TechnicalErrorComponent
    },
    { path: '**', pathMatch: 'full', redirectTo: '/accueil' },
];
